import { Injectable } from '@angular/core';
import { IID_EP_SUPPORT_GISFO } from '@common/interfaces/interfaceData';
import { Topics } from '@common/interfaces/topics';
import { ActionService } from '../action/action.service';
import { CrudService } from '../crudService';
import { IssueEntityStoreStrategy } from '../updateStoreStrategies';
import { IIDepGisfoSupportQuery } from './iidEPGisfoSupport.query';
import { IIDepGisfoSupportStore } from './iidEPGisfoSupport.store';

@Injectable({
  providedIn: 'root'
})
export class IIDepGisfoSupportService extends CrudService<IID_EP_SUPPORT_GISFO, IIDepGisfoSupportStore, IIDepGisfoSupportQuery> {
  constructor(
    protected store: IIDepGisfoSupportStore,
    protected query: IIDepGisfoSupportQuery,
    protected actionService: ActionService,
    protected updateStrategy: IssueEntityStoreStrategy,
  ) {
    super(
      Topics.IID_EP_GISFO_SUPPORT,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

}
